import { Button, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { useState } from "react";
import { renderClose } from "../../common/dialog";
import { createEntityStore } from "../../common/entityStore";
import { propTextField } from "../../common/entityStoreForm";
import { UseListStore } from "../../common/listStore";
import { EntityStoreSaveButton } from "../../common/SaveButton";

export const ResourceDialog = (props: {
    close: () => void;
    item: ResourceDto;
    onChange(): void;
    useListStore: UseListStore<ResourceDto>;
}) => {
    const [useStore] = useState(() => createEntityStore<ResourceDto>({
        data: props.item,
        path: "settings/resources",
        fetchOnInit: false,
        id: props.item.id,
        onSaved() {
            props.onChange();
            props.close();
        },
        propValidators: [
        ]
    }));
    return <>
        <DialogTitle>Edit resource</DialogTitle>
        {renderClose(props.close)}
        <DialogContent>
            <Grid container columnSpacing={2} alignItems="stretch">
                <Grid item xs={12}>{propTextField(useStore)("name", "Name", { disabled: true })}</Grid>
                <Grid item xs={12}>{propTextField(useStore)("language", "Language", { disabled: true })}</Grid>
                <Grid item xs={12}>{propTextField(useStore)("stringValue", "Value")}</Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <EntityStoreSaveButton useStore={useStore} />
            <Button onClick={props.close} color="negative" variant="outlined">Close</Button>
        </DialogActions>
    </>;
};

export interface ResourceDto {
    id: number;
    name: string;
    language: string | null;
    stringValue: string;
}
